import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch, useHistory } from "react-router-dom";

import Navigation from "../Navigation";
import SignInPage from "../SignIn";
import HomePage from "../Home";

import * as ROUTES from "../../constants/routes";
import { AuthUserContext, withAuthentication } from "../Session";
import CoursePage from "../Formation/CoursePage";
import theme from "../../constants/theme";
import { ThemeProvider } from "@material-ui/core/styles";
import EvaluationPage from "../Evaluation/EvaluationPage";
import ManagerPage from "../Manager/ManagerPage";
import "../../i18n";
import EvaluationPassed from "../Evaluation/EvaluationPassed";
import UserConfirmation from "../UserConfirmation";
import Rescuers from "../Rescuers";
import RequestPasswordChange from "../RequestPasswordChange";
import ResetPassword from "../ResetPassword";
import ProgramManagementPage from "../ProgramManagement/ProgramManagementPage";
import RealTimeAlerts from "../RealTimeAlerts";
import AlertScreen from "../RealTimeAlerts/AlertScreen";
import MetaForms from "../MetaForms";
import FormsManagement from "../FormsManagement";
import RescuerSignUp from "../RescuerSignUp";
import Reanibex_Alert_Policy from "../Reanibex_Alert_Policy";
import UserSignUp from "../UserSignUp";
import { blueGrey } from "@material-ui/core/colors";
import Ermua2022 from "../Ermua2022";
import OnsiteTrainingPage from "../OnsiteTrainingPage";
import HomeScreen from "../HomeScreen";
import { MotionLayoutProvider } from "react-motion-layout";
import CourseModule from "../CourseModule";
import { ErrorBoundary } from "react-error-boundary";
import { Button, makeStyles, Grid, Typography, Container } from "@material-ui/core";

import ErrorPage from "../ErrorPage";
import JustPassedModal from "../HomeScreen/JustPassedModal";
import CompletingProfile from "../RescuerSignUp/CompletingProfile";
import ReportPage from "../ReportPage";
import ComunicationTestPage from "../ComunicationTestPage";
import UserProfileScreen from "../Profile";
import R100Trainer_Policy from "../R100Trainer_Policy";

const App = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => window.location.reload(false)}>
      <Router>
        <ThemeProvider theme={theme}>
          <AuthUserContext.Consumer>{(authUser) => !!authUser && <Navigation authUser={authUser} />}</AuthUserContext.Consumer>
          <MotionLayoutProvider>
            <Switch style={{ background: blueGrey[50] }}>
              <Route path={ROUTES.SIGN_IN} component={SignInPage} />
              <Route path={ROUTES.HOME} exact render={(props) => <HomeScreen {...props} option={0} />} />
              <Route path={ROUTES.MODULE} exact render={(props) => <CourseModule {...props} />} />
              <Route path={ROUTES.EVALUATIONS} exact render={() => <HomePage option={1} />} />
              <Route path={ROUTES.COURSES} render={() => <CoursePage />} />
              <Route path={ROUTES.EVALUATION} exact render={() => <EvaluationPage />} />
              <Route path={ROUTES.EVALUATIONPASSED} render={() => <EvaluationPassed />} />
              <Route path={ROUTES.ACTIVERESCUER} render={() => <JustPassedModal />} />
              <Route path={ROUTES.MANAGER} render={() => <ManagerPage />} />
              <Route path={ROUTES.PROGRAMMANAGEMENT} render={() => <ProgramManagementPage />} />
              <Route path={ROUTES.USERCONFIRMATION} render={() => <UserConfirmation />} />
              <Route path={ROUTES.PASSWORD_FORGET} render={() => <RequestPasswordChange />} />
              <Route path={ROUTES.PASSWORDCHANGE} render={() => <ResetPassword />} />
              <Route path={ROUTES.RESCUERS} render={() => <Rescuers />} />
              <Route path={ROUTES.REAL_TIME_ALERS} render={() => <RealTimeAlerts />} />
              <Route path={ROUTES.ALERT_LOG} render={() => <AlertScreen />} />
              <Route path={ROUTES.METAFORMS} render={() => <MetaForms />} />
              <Route path={ROUTES.EDIT_METAFORM} render={() => <MetaForms />} />
              <Route path={ROUTES.MANAGE_FORMS} render={() => <FormsManagement />} />
              <Route path={ROUTES.RESCUERS_SIGNUP} render={() => <RescuerSignUp />} />
              <Route path={ROUTES.WAITINGFORCOMPLETEUSERACCOUNT} render={() => <CompletingProfile />} />
              <Route path={ROUTES.ERMUA2022} render={() => <Ermua2022 />} />
              <Route path={ROUTES.ONSITE_TRAINING} render={() => <OnsiteTrainingPage />} />
              <Route path={ROUTES.CREATE_ACCOUNT} render={() => <UserSignUp />} />
              <Route path={ROUTES.REANIBEX_ALERT_POLICY} render={() => <Reanibex_Alert_Policy />} />
              <Route path={ROUTES.REANIBEX_100_TRAINER_POLICY} render={() => <R100Trainer_Policy />} />
              <Route path={ROUTES.ERROR} render={() => <ErrorPage />} />
              <Route path={ROUTES.SENDREPORT} render={() => <ReportPage />} />
              <Route path={ROUTES.COMUNICATIONTEST} render={() => <ComunicationTestPage />} />
              <Route path={ROUTES.PROFILE} render={() => <UserProfileScreen />} />
              {/** redirigir cuando no se encuentre una ruta */}
              <Redirect to={ROUTES.HOME} />
            </Switch>
          </MotionLayoutProvider>
        </ThemeProvider>
      </Router>
    </ErrorBoundary>
  );
};

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return <ErrorPage reset={resetErrorBoundary} />;
};

export default withAuthentication(App);
